module.exports = __webpack_public_path__ + "static/Clothes4All-Beach-EN_original-4fc290c2b705f4beae42042e1bcb7881.mp4";